import { db } from '../dbConfigs';

export const vendorService = {
    getAll,
    add,
    getById,
    update,
    updateField,
    _delete,
};

async function getAll() {
    var ref = db.collection('vendors');
    var query = ref.orderBy('create_date', 'desc');
    const snapshot = await query.get();
    const vendors = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
    }));

    if (vendors && vendors.length > 0) {
        Promise.all(
            vendors.map(async (vendor, index) => {
                if (vendor.create_date) {
                    var _date = vendor['create_date'];
                    vendor['create_date'] = _date.toDate();
                }
                vendor['index'] = index + 1;
            })
        );
    }

    return vendors;
}

async function getById(id) {
    try {
        const doc = await db.collection("vendors").doc(id)
            .get();
        if (doc.exists) {
            return doc.data();
        } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
        }
    } catch (error) {
        console.log("Error getting document:", error);
    }
}

async function add(vendor) {
    try {
        const docRef = await db.collection("vendors").add(vendor);
        vendor.id = docRef.id;
        update(vendor);
        console.log("Firebase: vendor has been added successfully!");
        return vendor;
    } catch (error) {
        console.error("Error adding vendor: ", error);
    }
}

async function update(vendor) {
    //console.log(vendor);
    let dbRef = db.collection("vendors").doc(vendor['id']);

    try {
        //console.log(vendor);
        await dbRef.update(vendor).then(() => {
            console.log("Firebase: vendor has been updated successfully!");
        });

        return vendor;
    } catch (error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
        return error;
    }
}

async function updateField(vendor, field) {
    //console.log(vendor);
    let dbRef = db.collection("vendors").doc(vendor['id']);

    try {
        console.log(field, vendor[field]);
        await dbRef.update({
            [field]: vendor[field]
        }).then(() => {
            console.log("Firebase: vendor field has been updated successfully!");
        });

        return vendor;
    } catch (error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
        return error;
    }
}

async function _delete(vendor) {
    try {
        await db.collection("vendors").doc(vendor.id).delete().then((vendor) => {
            return vendor;
        });
    } catch (error) {
        console.error("Error: ", error);
    }
}
